<script setup lang="ts">
  import type { CalendarGridProps } from "reka-ui";
  import type { HTMLAttributes } from "vue";
  import { reactiveOmit } from "@vueuse/core";
  import { CalendarGrid } from "reka-ui";
  import { cn } from "@/lib/utils";

  const props = defineProps<CalendarGridProps & { class?: HTMLAttributes["class"] }>();

  const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <CalendarGrid
    :class="cn('w-full border-collapse space-y-1', props.class)"
    v-bind="delegatedProps">
    <slot />
  </CalendarGrid>
</template>
